export default "__VITE_ASSET__DoQycvxQ__"